(function(angular) {
  'use strict';

  angular.module('esn.calendar')
    .component('calSettingsSidebarButton', {
      template: require('./settings-sidebar-button.pug')
    });
})(angular);
